import PropTypes from "prop-types";
import React from "react";

// A single clean recap panel: a coloured header band (e.g. the company name)
// over a 2-column grid of label / value items separated by hairlines — instead
// of a scatter of individual stat cards.
// items: [{ label, value, wide? }] — `wide` spans the full width (e.g. counters).
export const RecapPanel = ({ header, icon, accentColor, items }) => {
  // With an odd number of regular items the last one would leave an empty cell;
  // span it full-width instead so the grid always fills complete rows.
  const normalIdxs = items
    .map((item, idx) => (item.wide ? -1 : idx))
    .filter((idx) => idx >= 0);
  const fillLast = normalIdxs.length % 2 === 1;
  const lastNormalIdx = normalIdxs[normalIdxs.length - 1];

  return (
    <section
      className="cf-recap2"
      style={accentColor ? { "--cf-accent": accentColor } : undefined}
    >
      {header && (
        <div className="cf-recap2__head" title={header}>
          {icon && <i className={icon} aria-hidden="true" />}
          <span className="cf-recap2__headtext">{header}</span>
        </div>
      )}
      <div className="cf-recap2__grid">
        {items.map((item, idx) => {
          const wide = item.wide || (fillLast && idx === lastNormalIdx);
          return (
            <div
              className={"cf-recap2__item" + (wide ? " is-wide" : "")}
              key={idx}
            >
              {item.label && (
                <span className="cf-recap2__label">{item.label}</span>
              )}
              <span className="cf-recap2__value">{item.value}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

RecapPanel.propTypes = {
  header: PropTypes.node,
  icon: PropTypes.string,
  accentColor: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node,
      wide: PropTypes.bool,
    })
  ).isRequired,
};
